const isDev = process.env.NODE_ENV !== "production";
const configured = (process.env.REACT_APP_BACKEND_URL || "").trim().replace(/\/+$/, "");

export const BACKEND_URL = configured || (isDev ? "http://localhost:8000" : "");

if (!BACKEND_URL) {
  // eslint-disable-next-line no-console
  console.error("Missing REACT_APP_BACKEND_URL. Set it at build time for production deployments.");
}

